import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=c4a64600&scoped=true"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionDetails.vue?vue&type=style&index=0&id=c4a64600&prod&scoped=true&lang=scss"
import style1 from "./SubscriptionDetails.vue?vue&type=style&index=1&id=c4a64600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a64600",
  null
  
)

export default component.exports